import { useState } from 'react';
import InputField from './InputField';
import '../../css/LoginPage.css';
import { useAuth } from "../../state/AuthContext";
import { useNavigate } from "react-router-dom";
import { signupUser } from '../../services/UserService.ts';
import { loginUser } from '../../services/UserService.ts';

const LoginForm = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mode, setMode] = useState('signup'); // 'signup' or 'login'

  const handleSignUp = async () => {
    try {
      await signupUser(email, password);
      await handleLogin(); // Automatically perform login only after signup succeeds.
    } catch (error) {
      alert('Signup failed. Please try again.');
      console.error(error);
    }
  };

  const handleLogin = async () => {
    try {
      await loginUser(email, password);
      login(); // for navbar
      navigate('/');
    } catch (error) {
      alert('Login failed. Please check your credentials and try again.');
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (mode === 'signup') {
      await handleSignUp();
    } else {
      await handleLogin();
    }
  };

  const toggleMode = (e) => {
    e.preventDefault(); 
    setMode(prevMode => (prevMode === 'signup' ? 'login' : 'signup'));
  };

  const isSignupMode = mode === 'signup';
  const headerText = isSignupMode ? 'Create an account to save your progress :)' : 'Log in to your account';
  const buttonText = isSignupMode ? 'Sign up for free' : 'Log in';
  const footerPrompt = isSignupMode ? 'Already have an account?' : "Don't have an account?";
  const footerLinkText = isSignupMode ? 'Log in' : 'Sign up';

  return (
    <div className="login-form-container">
      <div className="login-header">
        <img src="/assets/images/stick_guy.jpg" alt="computer icon" style={{width: '50px', marginRight: '10px'}}/>
        {headerText}
      </div>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="separator"></div>
        <InputField
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <InputField
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="login-button">
          {buttonText}
        </button>
        <div className="login-footer">
          {isSignupMode && <p>By signing up, I agree to Chalmers Terms.</p>}
          <p>
            {footerPrompt} <a href="/" onClick={toggleMode}>{footerLinkText}</a>
          </p>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;